import React from "react";
import { Box, Typography } from "@mui/material";

export default function Banner({
  backgroundImage, // URL de la imagen de fondo
  title, // Título principal
  subtitle, // Subtítulo o texto inferior
  subtitlePosition = "bottom", // "top" o "bottom"
  variant = "centered", // "centered" o "bottomLeft"
  section = "ejeAccion",
  extraContent,
  titleBackgroundColor
 
}) {
  return (
    <Box
      sx={{
        
            height: "100vh", // Usa toda la altura de la pantalla
            backgroundImage: `linear-gradient(180deg,rgba(0,0,0,0.5), rgba(0,0,0,0.0)), url(${backgroundImage})`,
            // backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",  // Ajusta la imagen para que cubra toda la pantalla
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat", // Evita que la imagen se repita
            display: "flex",
            flexDirection: "column",
            justifyContent: variant === "centered" ? "center" : "flex-end",
            alignItems: variant === "centered" ? "center" : "flex-start",
            textAlign: variant === "centered" ? "center" : "left",
            padding: variant === "centered" ? 0 : "0px",
            margin: 0,   // Evita márgenes no deseados
          
          
      }}
    >
      {/* Versión centrada */}
      {variant === "centered" ? (
        <>
            {/* SUBTÍTULO ARRIBA */}
            {subtitle && subtitlePosition === "top" && (
                <Typography  sx={{ marginBottom: 1, fontSize:{xs:'18px', sm:'24px', md:'30px'}, color: 'white', fontWeight:'400',textShadow:'0px 2px 10px rgb(0,0,0,0.5)', letterSpacing:1}}>
                {subtitle}
                </Typography>
            )}
            {/* TÍTULO CON FORMATO */}
            <Box>{title}</Box>

            {/* SUBTÍTULO ABAJO */}
            {subtitle && subtitlePosition === "bottom" && (
                <Typography variant="h6" sx={{ marginTop: 2 }}>
                {subtitle}
                </Typography>
            )}
            {/* EXTRA CONTENT (solo si existe) */}
            {extraContent && (
                <Box>{extraContent}
                </Box>
            )}
        </>
      ) : (
        // Versión con título abajo a la izquierda
        <Box sx={{width:'100%'}}>
            {/* EXTRA CONTENT (solo si existe) */}
            {extraContent && (
                <Box>{extraContent}
                </Box>
            )}
            
            <Box sx={{maxWidth:'min-content', whiteSpace:'nowrap'}}>
          <Typography
            
            sx={{

                backgroundColor: titleBackgroundColor,
                color: "white",
                borderRadius: "0rem 20rem 20rem 0rem",
                paddingLeft:{xs:'2rem', sm:'7rem'},
                paddingRight:3,
                boxShadow: section === "ejeAccion" ? '0px 2px 5px rgb(0,0,0,0.4)': 'none',
                textAlign:'left',textShadow:'0px 2px 10px rgb(0,0,0,0.1)', 
                fontSize:{xs:'40px', sm:'50px', md:'64px'},
                lineHeight:1.2,
                fontWeight:900
            }}
          >
            {title}
          </Typography>
          </Box>
          <Box sx={{color:'white'}}>
                {subtitle}
            </Box>
        </Box>
      )}
    </Box>
  );
}
